import React from 'react'
import { AccordionItem, TextBody, Space } from '@ally/metronome-ui'
import { StyledUl } from '../../../utils/commonStyledComponents'

export const eddFaqsContent: AccordionItem[] = [
  {
    heading: 'What is early direct deposit?',
    panel: (
      <Space mb="xs">
        <TextBody tabIndex={-1} size="sm" tag="p">
          Simply put, your paycheck is available up to 2 days before your
          regular payday. It&apos;s a free, automatic feature we offer so you
          can pay bills, manage expenses, or earn interest on your money sooner.
        </TextBody>
        <TextBody size="sm" tag="p">
          For example, if you normally get paid on Friday, you’ll now see your
          paycheck in your account as soon as Wednesday.
        </TextBody>
      </Space>
    ),
  },
  {
    heading: 'Do I need to sign up for early direct deposit?',
    panel: (
      <Space mb="xs">
        <>
          <TextBody tabIndex={-1} size="sm" tag="p">
            No, it&apos;s an automatic feature of our Spending Account. In most
            cases, you&apos;ll receive your paycheck early if:
          </TextBody>
          <StyledUl>
            <li>
              You receive recurring payments through an employer, business, or
              government program that uses direct deposit (and you&apos;re
              enrolled in direct deposit, too)
            </li>
            <li>
              We see 2 direct deposits to your Spending Account within 6 months
            </li>
            <li>
              Your payroll provider consistently sends us your payment details
              on time
            </li>
          </StyledUl>
        </>
      </Space>
    ),
  },
  {
    heading: 'How do I set up direct deposit?',
    panel: (
      <Space mb="xs">
        <TextBody tabIndex={-1} size="sm" tag="p">
          Go through your paycheck or government payment provider to enroll in
          direct deposit yourself.
        </TextBody>
        <TextBody tag="p" size="sm">
          You&apos;ll need:
        </TextBody>
        <StyledUl>
          <li>Our routing number: 124003116</li>
          <li>Your account number</li>
        </StyledUl>
      </Space>
    ),
  },
  {
    heading:
      'Is there a limit to how many early direct deposits I can receive?',
    panel: (
      <Space mb="xs">
        <TextBody tabIndex={-1} size="sm" tag="p">
          Yes. We allow up to 4 early direct deposits per account per statement
          cycle, and each paycheck must be $10,000 or less.
        </TextBody>
        <TextBody tag="p" size="sm">
          If you don&apos;t get your deposit early, expect it to arrive on your
          regularly-scheduled payday.
        </TextBody>
      </Space>
    ),
  },
  {
    heading: 'Does early direct deposit cost anything?',
    panel: (
      <Space mb="xs">
        <TextBody tabIndex={-1} size="sm" tag="p">
          No. It&apos;s completely free.
        </TextBody>
      </Space>
    ),
  },
  {
    heading: 'What happens if I change jobs?',
    panel: (
      <Space mb="xs">
        <TextBody tabIndex={-1} size="sm" tag="p">
          You&apos;ll need to set up direct deposit through your new payroll
          provider.
        </TextBody>
        <TextBody tag="p" size="sm">
          You&apos;ll remain qualified for early direct deposit as long as you
          received 2 eligible payroll deposits within the past 6 months, even
          from a prior employer.
        </TextBody>
      </Space>
    ),
  },
  {
    heading: 'Can I stop early direct deposit?',
    panel: (
      <Space mb="xs">
        <TextBody tabIndex={-1} size="sm" tag="p">
          No. Early direct deposit is a free, automatic feature that comes with
          our Spending Account. As long as you&apos;re eligible for early direct
          deposit, there&apos;s nothing stopping you from getting paid early.
        </TextBody>
      </Space>
    ),
  },
  {
    heading: `How will I know if I'm getting paid early?`,
    panel: (
      <Space mb="xs">
        <TextBody tabIndex={-1} size="sm" tag="p">
          We&apos;ll automatically let you know if you qualify, but you can also
          log in to your account and customize your direct deposit alerts.
        </TextBody>
      </Space>
    ),
  },
  {
    heading: `Why isn't my direct deposit coming in early?`,
    panel: (
      <Space mb="xs">
        <TextBody tabIndex={-1} size="sm" tag="p">
          It depends. If we can&apos;t process your direct deposit early, it
          could be because:
        </TextBody>
        <StyledUl>
          <li>
            You recently set up direct deposit or we didn&apos;t receive your
            payment details on time for another reason
          </li>
          <li>
            Your deposit type isn&apos;t eligible (like a transfer between bank
            accounts)
          </li>
          <li>You reached the transaction or monthly deposit amount limit</li>
        </StyledUl>
      </Space>
    ),
  },
  {
    heading:
      'What if I get part of my direct deposit sent to my savings or money market account?',
    panel: (
      <Space mb="xs">
        <TextBody tabIndex={-1} size="sm" tag="p">
          As long as some of your direct deposit goes into your spending account
          and you receive your money early, it&apos;ll show up early in all your
          in all your accounts.
        </TextBody>
      </Space>
    ),
  },
]
